export default "__VITE_ASSET__DszocPZ4__"